import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "w-full max-w-xl p-8 flex flex-col space-y-4" };
const _hoisted_2 = { class: "flex flex-row items-start space-x-2" };
const _hoisted_3 = { class: "flex -ml-3" };
const _hoisted_4 = { class: "text-xl font-semibold text-gray-900 self-center" };
const _hoisted_5 = { class: "text-base font-regular leading-normal text-gray-600 pb-2" };
const _hoisted_6 = { class: "w-full justify-start flex flex-col space-y-4" };
const _hoisted_7 = { class: "flex w-full justify-between space-x-2" };
const _hoisted_8 = {
    key: 0,
    class: "flex justify-between p-4 mt-3 text-md font-semibold leading-none text-white bg-danger-400 border-danger-600 rounded-lg"
};
const _hoisted_9 = { class: "flex w-3/4" };
const _hoisted_10 = { class: "flex flex-end justify-end space-x-4" };
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { BaseButton } from '@/lib/components/Button';
import { BaseIcon } from '@/lib/components/Icon';
import { BaseSelect } from '@/lib/components/Select';
import { BaseCheckbox } from '@/lib/components/Checkbox';
import { BaseDatePicker } from '@/lib/components/Date';
import { CopdConsultType } from '@/models';
import { CopdProgramService } from '@/services/api';
import { consultTypes } from '@/helpers/home-monitoring.helper';
import isToday from 'dayjs/plugin/isToday';
import dayjs from 'dayjs';
import { useNotificationStore } from '@/stores/notification.store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SetNextConsultModal',
    props: {
        programId: {
            type: String,
            required: true
        },
        nextConsult: {
            type: Object,
            default: null
        }
    },
    emits: ["close"],
    setup(__props, { emit }) {
        const props = __props;
        dayjs.extend(isToday);
        const { t } = useI18n();
        const patientScheduledExternally = ref(false);
        const consult = ref({ scheduled_at: '', type: CopdConsultType.homeVisit });
        const errors = ref({
            errors: {},
            message: ''
        });
        const copdProgramService = new CopdProgramService();
        const submitting = ref(false);
        const notificationStore = useNotificationStore();
        const today = computed(() => dayjs().format('YYYY-MM-DD'));
        const ensureScheduledAtIsOnOrAfterToday = computed(() => (consult.value.scheduled_at &&
            (consult.value.scheduled_at >= today.value)));
        const consultTypeList = computed(() => consultTypes);
        onMounted(() => {
            if (props.nextConsult &&
                (dayjs().isBefore(dayjs(props.nextConsult.scheduled_at)) || dayjs(props.nextConsult.scheduled_at).isToday())) {
                consult.value = {
                    scheduled_at: props.nextConsult.scheduled_at,
                    type: props.nextConsult.type
                };
            }
        });
        const closeModal = () => {
            emit('close');
        };
        const setNextConsult = async () => {
            try {
                submitting.value = true;
                await copdProgramService.setNextConsult(props.programId, consult.value);
                emit('close', true);
                notificationStore.snackbar = {
                    label: t('custom.uhb.copd.schedule-next-consult-completed')
                };
            }
            catch (e) {
                errors.value = e.response.data;
            }
            finally {
                submitting.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(BaseIcon), {
                            name: "outcome",
                            stroke: false,
                            height: "2.5rem"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('custom.uhb.copd.schedule-next-consult')), 1)
                ]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('custom.uhb.copd.schedule-next-consult-desc')), 1),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(BaseDatePicker), {
                            modelValue: consult.value.scheduled_at,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((consult.value.scheduled_at) = $event)),
                            error: errors.value && errors.value.errors.scheduled_at && errors.value.errors.scheduled_at[0],
                            label: _ctx.$t('custom.uhb.copd.next-consult-at'),
                            "min-date": _unref(today),
                            placeholder: _ctx.$t('custom.uhb.copd.select-next-consult-at'),
                            "data-dusk": "set-next-consult-date-picker"
                        }, null, 8, ["modelValue", "error", "label", "min-date", "placeholder"]),
                        _createVNode(_unref(BaseSelect), {
                            modelValue: consult.value.type,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((consult.value.type) = $event)),
                            class: "h-full flex-1",
                            error: errors.value && errors.value.errors.type && errors.value.errors.type[0],
                            label: _ctx.$t('custom.uhb.copd.next-consult-type'),
                            options: _unref(consultTypeList),
                            placeholder: _ctx.$t('custom.uhb.copd.select-next-consult-type'),
                            "data-dusk": "set-next-consult-consult-type"
                        }, null, 8, ["modelValue", "error", "label", "options", "placeholder"])
                    ]),
                    _createVNode(_unref(BaseCheckbox), {
                        modelValue: patientScheduledExternally.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((patientScheduledExternally).value = $event)),
                        label: _ctx.$t('custom.uhb.copd.patient-scheduled-externally'),
                        shadow: true,
                        border: true,
                        "data-dusk": "set-next-consult-patient-scheduled-externally"
                    }, null, 8, ["modelValue", "label"]),
                    (errors.value && errors.value.message)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(errors.value.message), 1)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_unref(BaseButton), {
                            class: "mt-8",
                            size: "large",
                            color: "ghost",
                            onClick: closeModal
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('platform.common.cancel')), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_unref(BaseButton), {
                            class: "mt-8",
                            size: "large",
                            color: "primary",
                            disabled: !patientScheduledExternally.value || !_unref(ensureScheduledAtIsOnOrAfterToday),
                            loading: submitting.value,
                            onClick: setNextConsult
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('platform.common.update')), 1)
                            ]),
                            _: 1
                        }, 8, ["disabled", "loading"])
                    ])
                ])
            ]));
        };
    }
});
